/**
 * The composer is closed while the panel can't send (signed out of Wavebox).
 * The server says so with `data-disabled` on the editor, which LiveView keeps
 * updating even though the editor is `phx-update="ignore"`; the editor's own
 * attributes are set here to match.
 * @param {{dataset: object, contentEditable: string, setAttribute: Function}} editor - the composer's editor element
 * @returns {boolean} whether the composer is closed
 */
export function applyComposerDisabled (editor) {
  const disabled = editor.dataset.disabled === 'true'
  editor.contentEditable = disabled ? 'false' : 'true'
  editor.setAttribute('aria-disabled', String(disabled))
  return disabled
}

/**
 * @param {{dataset: object}} editor - the composer's editor element
 * @returns {boolean} whether a send must be ignored, leaving the text where it is
 */
export function composerDisabled (editor) {
  return editor.dataset?.disabled === 'true'
}
